<template>
    <!-- User Profile Personal Basic Info Tab Content View From Account Profile -->
    <div>
        <div class="tabs-content-secondblock">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ml-2 mr-1 mb-3">
                        <div class="row" v-if="ajax_call_in_progress">
                            <div class="col-lg-12 py-5 px-3 mt-10">
                                <div class="flex-container">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
                                </div>
                            </div>
                        </div>
                        <div v-else class="row">
                            <div class="col-lg-12">
                                <div class="infoHeader pb-4">
                                    <div class="a-q-Jc-j-contactView mt-1">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView ">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">First Name<span class="pl-1 text-danger">*</span></div>
                                            <div class="w-100" style="position: relative;">
                                                <div class="d-flex justify-content-end align-items-center new-action-btns" style="bottom: 30px;" v-if="edit_first_name" >
                                                    <div class="pointer" @click="resetValue('first_name')">
                                                        <img src="/static/images/check.svg">
                                                    </div>
                                                    <div class="ml-2 pointer" @click="updateInfo('first_name')">
                                                        <img src="/static/images/close.svg">
                                                    </div>
                                                </div>
                                                <el-tooltip class="item" effect="dark"
                                                        content="Click to edit"
                                                        placement="top">
                                                <input name='first_name' v-validate="'required'" class="inputField" @focus="editUser('first_name')" style="padding-top: 6px !important;" :readonly="!edit_first_name" maxlength="20" v-model="edit_user_data.first_name">
                                                </el-tooltip>
                                                <div class="d-flex justify-content-between align-items-center" >
                                                    <span class="validation" v-show="errors.has('first_name')">
                                                        This field is required
                                                    </span>
                                                    <span class="fs-13 text-right d-block ml-auto" v-if="edit_first_name">{{(edit_user_data.first_name).length}}/20</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView mt-10">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView ">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Middle Name</div>
                                            <div class="w-100" style="position: relative;">
                                                <div class="d-flex justify-content-end align-items-center new-action-btns" style="bottom: 30px;" v-if="edit_middle_name" >
                                                    <div class="pointer" @click="resetValue('middle_name')">
                                                        <img src="/static/images/check.svg">
                                                    </div>
                                                    <div class="ml-2 pointer" @click="updateInfo('middle_name')">
                                                        <img src="/static/images/close.svg">
                                                    </div>
                                                </div>
                                                <el-tooltip class="item" effect="dark"
                                                        content="Click to edit"
                                                        placement="top">
                                                <input class="inputField" @focus="editUser('middle_name')" style="padding-top: 6px !important;" maxlength=20 :readonly="!edit_middle_name" v-model="edit_user_data.middle_name">
                                                </el-tooltip>
                                                <div class="d-flex justify-content-end align-items-center" v-if="edit_middle_name" >
                                                    <span class="fs-13 text-right d-block">{{(edit_user_data.middle_name).length}}/20</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView mt-10">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView ">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Last Name<span class="pl-1 text-danger">*</span></div>
                                            <div class="w-100" style="position: relative;">
                                                <div class="d-flex justify-content-end align-items-center new-action-btns" style="bottom: 30px;" v-if="edit_last_name" >
                                                    <div class="pointer" @click="resetValue('last_name')">
                                                        <img src="/static/images/check.svg">
                                                    </div>
                                                    <div class="ml-2 pointer" @click="updateInfo('last_name')">
                                                        <img src="/static/images/close.svg">
                                                    </div>
                                                </div>
                                                <el-tooltip class="item" effect="dark"
                                                        content="Click to edit"
                                                        placement="top">
                                                <input name='last_name' v-validate="'required'" maxlength="20" class="inputField" @focus="editUser('last_name')" style="padding-top: 6px !important;" :readonly="!edit_last_name" v-model="edit_user_data.last_name">
                                                </el-tooltip>
                                                <div class="d-flex justify-content-between align-items-center" >
                                                    <span class="validation" v-show="errors.has('last_name')">
                                                        This field is required
                                                    </span>
                                                    <span class="fs-13 text-right d-block ml-auto" v-if="edit_last_name">{{(edit_user_data.last_name).length}}/20</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView mt-10">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView ">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Gender<span class="pl-1 text-danger">*</span></div>
                                            <div v-if="edit_gender" class="w-100" style="font-weight:600;position: relative;">
                                                <div v-if="edit_gender" style="z-index: 2;" class="d-flex justify-content-end align-items-center new-action-btns" >
                                                    <div class="pointer" @click="resetValue('gender')">
                                                        <img src="/static/images/check.svg">
                                                    </div>
                                                    <div class="ml-2 pointer" @click="updateInfo('gender')">
                                                        <img src="/static/images/close.svg">
                                                    </div>
                                                </div>
                                                <div v-if="!custom_gender_active" class="form-check form-check-inline mt-2 ml-1">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="radio" :readonly="!edit_gender" @change="maleGender" v-validate="'required'" v-model="edit_user_data.gender" name="vendor_type" value="Male">
                                                        <span class="radio-icon"></span>
                                                        <span class="form-check-description mt-1px">Male</span>
                                                    </label>
                                                </div>
                                                <div v-if="!custom_gender_active" class="form-check form-check-inline ml-5">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="radio" :readonly="!edit_gender" @change="femaleGender" v-model="edit_user_data.gender" v-validate="'required'" name="vendor_type" value="Female">
                                                        <span class="radio-icon"></span>
                                                        <span class="form-check-description mt-1px">Female</span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline" :class="{'w-100':custom_gender_active, 'ml-5':!custom_gender_active}">
                                                    <label class="form-check-label" :class="{'w-100':custom_gender_active}">
                                                        <input class="form-check-input" type="radio" :readonly="!edit_gender" @change="customGenderChange" v-model="edit_user_data.gender" v-validate="'required'" name="vendor_type" value="Custom">
                                                        <span class="radio-icon"></span>
                                                        <span class="form-check-description mt-1px">Custom<input style="border-bottom:1px solid black" v-if="gender_radio == 'Custom'" type="text"></span>
                                                        <div v-if="custom_gender_active" class="w-100" style="position: relative;">
                                                            <input name="gender" :maxlength="maxlengthcustomname" v-validate="'required'" type="text" v-model="edit_user_data.custom_gender" style="margin-top: -3px; margin-left: 10px; padding-right: 60px; border-bottom: 1px solid; background: transparent; width: 98%;">
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                            <el-tooltip v-else class="item" effect="dark"
                                                        content="Click to edit"
                                                        placement="top">
                                                <div class="w-100" @click="editUser('gender')">
                                                    <div v-if="edit_user_data.custom_gender.length>0" class="inputField">
                                                        {{edit_user_data.custom_gender}}
                                                    </div>
                                                    <div v-else class="inputField">
                                                        {{edit_user_data.gender}}
                                                    </div>
                                                </div>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView mt-10">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView ">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">
                                                Date of Birth
                                            </div>
                                            <div class="w-100" style="position: relative;">
                                                <div class="d-flex justify-content-end align-items-center new-action-btns" style="z-index: 2;" v-if="edit_date_of_birth" >
                                                    <div class="pointer" @click="resetValue('date_of_birth')">
                                                        <img src="/static/images/check.svg">
                                                    </div>
                                                    <div class="ml-2 pointer" @click="updateInfo('date_of_birth')">
                                                        <img src="/static/images/close.svg">
                                                    </div>
                                                </div>
                                                <el-tooltip class="item" effect="dark"
                                                        content="Click to edit"
                                                        placement="top">
                                                <date-picker class="profile-date-picker" @focus="editUser('date_of_birth')" :disabled="$route.params.id != loggedInUser.user_id" v-model="edit_user_data.date_of_birth" value-type="format" lang="en" :not-after="new Date()" type="date" format="DD/MM/YYYY"></date-picker>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView mt-10">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView align-items-start" style="position: relative;">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">About</div>
                                            <div class="w-100" :class="{'pr-12':edit_about, 'pr-0':!edit_about}">
                                                <el-tooltip class="item" effect="dark"
                                                        content="Click to edit"
                                                        placement="top">
                                                <textarea class="inputField" @focus="editUser('about')" style="padding-top: 6px !important; padding-right: 10px !important;" maxlength=1000 :readonly="!edit_about" v-model="edit_user_data.about" />
                                                </el-tooltip>
                                                <div class="d-flex justify-content-end align-items-center" v-if="edit_about" >
                                                    <span class="fs-13 text-right d-block">{{(edit_user_data.about).length}}/1000</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-end align-items-center new-action-btns" style="top: 0px; bottom: auto; right: 10px;" v-if="edit_about" >
                                                <div class="pointer" @click="resetValue('about')">
                                                    <img src="/static/images/check.svg">
                                                </div>
                                                <div class="ml-2 pointer" @click="updateInfo('about')">
                                                    <img src="/static/images/close.svg">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="a-q-Jc-j-contactView mt-10" v-if="loggedInUser.account_type == 'business'">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView align-items-start" style="position: relative;">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Job Description
                                            <sup class="fs-14 ml-1 mandatory">
                                                <el-tooltip
                                                class="item"
                                                effect="dark"
                                                content="The job description is derived from HRMS"
                                                placement="right"
                                                >
                                                <i class="icon-information text-secondary" style="font-size: 14px"></i>
                                                </el-tooltip>
                                            </sup></div>
                                            <div class="w-100" :class="{'pr-12':edit_job_description, 'pr-0':!edit_job_description}">
                                                <el-tooltip class="item" effect="dark"
                                                        content="Click to edit"
                                                        placement="top">
                                                <textarea class="inputField" @focus="editUser('job_description')" style="padding-top: 6px !important;padding-right: 10px !important;" :readonly="!edit_job_description" v-model="edit_user_data.job_description" />
                                                </el-tooltip>
                                                <div class="d-flex justify-content-end align-items-center" v-if="edit_job_description" >
                                                    <span class="fs-13 text-right d-block">{{(edit_user_data.job_description).length}}/1000</span>
                                                </div>
                                                <div class="d-flex justify-content-end align-items-center new-action-btns" style="bottom: auto; top: 0;right: 10px;" v-if="edit_job_description" >
                                                    <div class="pointer" @click="resetValue('job_description')">
                                                        <img src="/static/images/check.svg">
                                                    </div>
                                                    <div class="ml-2 pointer" @click="updateInfo('job_description')">
                                                        <img src="/static/images/close.svg">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="a-q-Jc-j-contactView mt-10" v-if="loggedInUser.account_type == 'business'">
                                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView ">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">User Access</div>
                                            <div class="w-100" style="padding-top:6px !important;font-weight:600">
                                                {{edit_user_data.user_access || "-"}}
                                                <sup class="fs-14 ml-1 mandatory">
                                                    <el-tooltip class="item" effect="dark"
                                                        content="Please contact system administrator to change the user access"
                                                        placement="right">
                                                        <i class="icon-information text-secondary" style="font-size: 14px"></i>
                                                    </el-tooltip>
                                                </sup>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="loggedInUser.account_type == 'business'">
                                        <div class="col-lg-12">
                                            <div class="infoHeader mt-4 pb-4">
                                                <div class="a-q-Jc-j-editcontactView">
                                                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                                                        <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3 font-weight-bold">Tax ID
                                                            <sup class="fs-14 ml-1 mandatory">
                                                                <el-tooltip class="item" effect="light" content="The options for this field are configurable in the Settings page" placement="right">
                                                                    <i class="icon-information text-secondary" style="font-size: 14px"></i>
                                                                </el-tooltip>
                                                            </sup>
                                                        </div>
                                                        <div class="a-q-Jc-Lb-editcontactView1 flex-column">
                                                            <div v-for="(tax_id, index) in edit_user_data.tax_id" :key="index" class="a-q-Jc-wg-editcontactView d-flex justify-content-between" style="position: relative;">
                                                                <div class="d-flex">
                                                                    <multiselect :disabled="$route.params.id != loggedInUser.user_id" class="digi-multiselect mr-2" v-model="edit_user_data.tax_id[index].tax_id_type" :options="['SSN','EIN']" :hide-selected="true" :close-on-select="true" :show-labels="false" placeholder="Type" open-direction="bottom" style="margin-top: 1px; width: 100px !important;"></multiselect>
                                                                    <input @focus="editUser('tax_id', index)" @input="goToNextInput($event, index)" :ref="`tax${index}1`"  v-model="edit_user_data.tax_id[index].tax1" :readonly="!edit_tax_id" type="text" class="otpTextInput" maxlength="1">
                                                                    <input @focus="editUser('tax_id', index)" @input="goToNextInput($event, index)" :ref="`tax${index}2`" v-model="edit_user_data.tax_id[index].tax2" :readonly="!edit_tax_id" type="text" class="otpTextInput" maxlength="1">
                                                                    <input @focus="editUser('tax_id', index)" @input="goToNextInput($event, index)" :ref="`tax${index}3`" v-model="edit_user_data.tax_id[index].tax3" :readonly="!edit_tax_id" type="text" class="otpTextInput" maxlength="1">
                                                                    <input @focus="editUser('tax_id', index)" @input="goToNextInput($event, index)" :ref="`tax${index}4`" v-model="edit_user_data.tax_id[index].tax4" :readonly="!edit_tax_id" type="text" class="otpTextInput" maxlength="1">
                                                                    <input @focus="editUser('tax_id', index)" @input="goToNextInput($event, index)" :ref="`tax${index}5`" v-model="edit_user_data.tax_id[index].tax5" :readonly="!edit_tax_id" type="text" class="otpTextInput" maxlength="1">
                                                                    <input @focus="editUser('tax_id', index)" @input="goToNextInput($event, index)" :ref="`tax${index}6`" v-model="edit_user_data.tax_id[index].tax6" :readonly="!edit_tax_id" type="text" class="otpTextInput" maxlength="1">
                                                                    <input @focus="editUser('tax_id', index)" @input="goToNextInput($event, index)" :ref="`tax${index}7`" v-model="edit_user_data.tax_id[index].tax7" :readonly="!edit_tax_id" type="text" class="otpTextInput" maxlength="1">
                                                                    <input @focus="editUser('tax_id', index)" @input="goToNextInput($event, index)" :ref="`tax${index}8`" v-model="edit_user_data.tax_id[index].tax8" :readonly="!edit_tax_id" type="text" class="otpTextInput" maxlength="1">
                                                                    <div class="d-flex justify-content-end align-items-center" v-if="edit_tax_id && tax_id_index == index">
                                                                        <div class="pointer" @click="resetValue('tax_id', index)">
                                                                            <img src="/static/images/check.svg">
                                                                        </div>
                                                                        <div class="ml-2 pointer" @click="updateInfo('tax_id', index)">
                                                                            <img src="/static/images/close.svg">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-if="$route.params.id == loggedInUser.user_id" class="d-flex align-items-center">
                                                                    <span style="cursor: pointer;" @click="deleteTaxId(index)">
                                                                        <img class="mr-2" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/trash.svg" style="height: 15px;" />
                                                                    </span>
                                                                    <span style="cursor: pointer;" @click="resetTaxIds(index)">
                                                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset-icon-default-blue.svg" style="height: 15px;" />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div v-if="tax_id_error" class="mt-2">
                                                                <span class="text-danger fs-14" >{{tax_id_error}}</span>
                                                            </div>
                                                            <div v-if="$route.params.id == loggedInUser.user_id" class="text-right mr-2 mt-5">
                                                                <button class="btn btn-secondary" style="border-radius:10px !important;" @click="addNewTaxId">+ Add Tax ID</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import { ValidationProvider } from 'vee-validate';
    import {
        User
    } from "./mixins/user";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import profile from "./mixins/profile";
    import DatePicker from 'vue2-datepicker'
    import Element from 'element-ui'
    // import ContactSuggestions from "./ContactSuggestions";
    // import QrcodeVue from "qrcode.vue";
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    export default {
        props: ['basic_info_data'],
        components:{
            DatePicker,
            Element,
            // VeeValidate
            ValidationProvider,
            HalfCircleSpinner
        },
        data() {
            return {
                edited_information: {
                    //  first_name: "",

                    about: "",
                },
                maxlengthcustomname:15,
                custom_gender_active: false,
                about_editing: false,
                basic_editing: false,
                edit_user_data: {
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    date_of_birth: '',
                    about: '',
                    job_description: '',
                    gender: '',
                    custom_gender: '',
                    user_access: '',
                    tax_id: [{
                        tax1: '',
                        tax2: '',
                        tax3: '',
                        tax4: '',
                        tax5: '',
                        tax6: '',
                        tax7: '',
                        tax8: '',
                        tax_id: '',
                        tax_id_type: ''
                    }],
                },
                edit_first_name: false,
                edit_middle_name: false,
                edit_last_name: false,
                edit_gender: '',
                edit_date_of_birth: false,
                edit_about: false,
                gender_radio: '',
                edit_job_description: false,
                edit_tax_id: false,
                // valueqr: "https://example.com",
                // size: 90,
                user_data: {},
                ajax_call_in_progress: false,
                tax_id_error: '',
                tax_id_index: ''
            };
        },
        mixins: [User, profile],
        methods: {
            moment(date) {
                return moment(date);
            },
            basic_enableEditing() {
                this.basic_editing = true;
            },
            basic_disableEditing() {
                this.basic_editing = false;
            },
            about_enableEditing() {
                this.about_editing = true;
            },
            about_disableEditing() {
                this.about_editing = false;
            },
            customDeselected() {
                if (this.custom_gender_active) {
                    this.custom_gender_active = false;
                    this.edit_user_data.gender = "Male";
                }
            },
            editUser(obj, index){
                if(this.$route.params.id == this.loggedInUser.user_id) {
                    if(obj == 'first_name'){
                        this.edit_first_name = true;
                        this.edit_middle_name = false;
                        this.edit_last_name = false;
                        this.edit_gender = false;
                        this.edit_date_of_birth = false;
                        this.edit_about = false;
                        this.edit_job_description = false;
                        this.edit_tax_id = false;
                    }
                    else if(obj == 'middle_name'){
                        this.edit_first_name = false;
                        this.edit_middle_name = true;
                        this.edit_last_name = false;
                        this.edit_gender = false;
                        this.edit_date_of_birth = false;
                        this.edit_about = false;
                        this.edit_job_description = false;
                        this.edit_tax_id = false;
                    }
                    else if(obj == 'last_name'){
                        this.edit_first_name = false;
                        this.edit_middle_name = false;
                        this.edit_last_name = true;
                        this.edit_gender = false;
                        this.edit_date_of_birth = false;
                        this.edit_about = false;
                        this.edit_job_description = false;
                        this.edit_tax_id = false;
                    }
                    else if(obj == 'gender'){
                        this.edit_first_name = false;
                        this.edit_middle_name = false;
                        this.edit_last_name = false;
                        this.edit_gender = true;
                        if(this.user_data.custom_gender.length > 0) {
                            // this.custom_gender_active = true;
                            this.edit_user_data.gender = 'Custom';
                            this.edit_user_data.custom_gender = this.user_data.custom_gender;
                        } else {
                            this.edit_user_data.gender = this.user_data.gender
                            this.edit_user_data.custom_gender = ''
                        }
                        this.edit_date_of_birth = false;
                        this.edit_about = false;
                        this.edit_job_description = false;
                        this.edit_tax_id = false;
                    }
                    else if(obj == 'date_of_birth'){
                        this.edit_first_name = false;
                        this.edit_middle_name = false;
                        this.edit_last_name = false;
                        this.edit_gender = false;
                        this.edit_date_of_birth = true;
                        this.edit_about = false;
                        this.edit_job_description = false;
                        this.edit_tax_id = false;
                    }
                    else if(obj == 'about'){
                        this.edit_first_name = false;
                        this.edit_middle_name = false;
                        this.edit_last_name = false;
                        this.edit_gender = false;
                        this.edit_date_of_birth = false;
                        this.edit_about = true;
                        this.edit_job_description = false;
                        this.edit_tax_id = false;
                    }
                    else if(obj == 'job_description'){
                        this.edit_first_name = false;
                        this.edit_middle_name = false;
                        this.edit_last_name = false;
                        this.edit_gender = false;
                        this.edit_date_of_birth = false;
                        this.edit_about = false;
                        this.edit_job_description = true;
                        this.edit_tax_id = false;
                    }
                    else if(obj == 'tax_id'){
                        this.edit_first_name = false;
                        this.edit_middle_name = false;
                        this.edit_last_name = false;
                        this.edit_gender = false;
                        this.edit_date_of_birth = false;
                        this.edit_about = false;
                        this.edit_job_description = false;
                        this.edit_tax_id = true;
                        this.tax_id_index = index;
                    }
                }
            },
            customGenderChange(data) {
                if(data.target.value == 'Custom') {
                    this.custom_gender_active = true;
                }
            },
            femaleGender(data) {
                if(data.target.value == 'Female') {
                    this.edit_user_data.gender = 'Female';
                    this.edit_user_data.custom_gender = '';
                }
            },
            maleGender(data) {
                if(data.target.value == 'Male') {
                    this.edit_user_data.gender = 'Male';
                    this.edit_user_data.custom_gender = '';
                }
            },
            resetValue(obj, index){
                if(obj == 'first_name'){
                    this.edit_first_name = false;
                    this.edit_user_data.first_name = this.user_data.first_name
                }
                else if(obj == 'middle_name'){
                    this.edit_middle_name = false;
                    this.edit_user_data.middle_name = this.user_data.middle_name
                }
                else if(obj == 'last_name'){
                    this.edit_last_name = false;
                    this.edit_user_data.last_name = this.user_data.last_name
                }
                else if(obj == 'gender'){
                    this.edit_gender = false;
                    if(this.custom_gender_active) {
                        this.custom_gender_active = false;
                    }
                    if(this.user_data.custom_gender.length > 0) {
                        this.edit_user_data.gender = 'Custom';
                        this.edit_user_data.custom_gender = this.user_data.custom_gender;
                    } else {
                        this.edit_user_data.gender = this.user_data.gender
                        this.edit_user_data.custom_gender = ''
                    }
                }
                else if(obj == 'date_of_birth'){
                    this.edit_date_of_birth = false;
                    this.edit_user_data.date_of_birth = this.user_data.date_of_birth.split('-')[2]+'/'+this.user_data.date_of_birth.split('-')[1]+'/'+this.user_data.date_of_birth.split('-')[0];
                }
                else if(obj == 'about'){
                    this.edit_about = false;
                    this.edit_user_data.about = this.user_data.about
                }
                else if(obj == 'job_description'){
                    this.edit_job_description = false;
                    this.edit_user_data.job_description = this.user_data.job_description
                }
                else if(obj == 'tax_id'){
                    this.edit_tax_id = false;
                    this.tax_id_error = '';
                    let n = this.user_data.tax_details[index].tax_id.split("");
                    this.user_data.tax_details[index] = {
                        tax1: n[0] == undefined ? '' : n[0],
                        tax2: n[1] == undefined ? '' : n[1],
                        tax3: n[2] == undefined ? '' : n[2],
                        tax4: n[3] == undefined ? '' : n[3],
                        tax5: n[4] == undefined ? '' : n[4],
                        tax6: n[5] == undefined ? '' : n[5],
                        tax7: n[6] == undefined ? '' : n[6],
                        tax8: n[7] == undefined ? '' : n[7],
                        tax_id: this.user_data.tax_details[index].tax_id,
                        tax_id_type: this.user_data.tax_details[index].tax_id_type,
                    }
                    this.edit_user_data.tax_id[index] = this.user_data.tax_details[index];
                }
            },
            addNewTaxId() {
                this.edit_user_data.tax_id.push({
                    tax1: '',
                    tax2: '',
                    tax3: '',
                    tax4: '',
                    tax5: '',
                    tax6: '',
                    tax7: '',
                    tax8: '',
                    tax_id: '',
                    tax_id_type: ''
                });
            },
            async deleteTaxId(index) {
                this.tax_id_error = '';
                this.edit_user_data.tax_id.splice(index,1);
                let params = {
                }
                params.tax_details = this.edit_user_data.tax_id;
                params.tax_details.forEach((el)=>{
                    el.tax_id = el.tax1+el.tax2+el.tax3+el.tax4+el.tax5+el.tax6+el.tax7+el.tax8
                    delete el.tax1;
                    delete el.tax2;
                    delete el.tax3;
                    delete el.tax4;
                    delete el.tax5;
                    delete el.tax6;
                    delete el.tax7;
                    delete el.tax8;
                });
                let response = await this.updatePersonalInfo(params, this.loggedInUser.user_id);
                if(response.status_id == 1) {
                    this.personalInfoData();
                    EventBus.$emit('personal_info_data_update')
                }
            },
            resetTaxIds(index) {
                this.edit_user_data.tax_id[index].tax1 = '';
                this.edit_user_data.tax_id[index].tax2 = '';
                this.edit_user_data.tax_id[index].tax3 = '';
                this.edit_user_data.tax_id[index].tax4 = '';
                this.edit_user_data.tax_id[index].tax5 = '';
                this.edit_user_data.tax_id[index].tax6 = '';
                this.edit_user_data.tax_id[index].tax7 = '';
                this.edit_user_data.tax_id[index].tax8 = '';
                this.edit_user_data.tax_id[index].tax8 = '';
                this.edit_user_data.tax_id[index].tax_id = '';
                this.edit_user_data.tax_id[index].tax_id_type = '';
            },
            goToNextInput(e) {
                if (e.target.value && e.target.nextElementSibling && e.keyCode != 8) {
                    e.target.nextElementSibling.focus();
                } else {
                    e.target.previousElementSibling.focus();
                }
            },
            async personalInfoData() {
                this.ajax_call_in_progress = true;
                try {
                    let param = this.$route.params.id ? this.$route.params.id : this.loggedInUser.user_id;
                    let response = await this.getPersonalInfo(param);
                    if (response.status_id == 1) {
                        this.edit_first_name = false;
                        this.edit_middle_name = false;
                        this.edit_last_name = false;
                        this.edit_gender = false;
                        this.edit_date_of_birth = false;
                        this.edit_about = false;
                        this.edit_job_description = false;
                        this.edit_tax_id = false;
                        this.custom_gender_active = false;
                        this.user_data = response.response;
                        this.edit_user_data.first_name = this.user_data.first_name;
                        this.edit_user_data.middle_name = this.user_data.middle_name;
                        this.edit_user_data.last_name = this.user_data.last_name;
                        this.edit_user_data.date_of_birth = this.user_data.date_of_birth.split('-')[2]+'/'+this.user_data.date_of_birth.split('-')[1]+'/'+this.user_data.date_of_birth.split('-')[0];
                        this.edit_user_data.about = this.user_data.about;
                        this.edit_user_data.job_description = this.user_data.job_description;
                        this.edit_user_data.gender = this.user_data.gender;
                        this.edit_user_data.custom_gender = this.user_data.custom_gender;
                        this.edit_user_data.user_access = this.user_data.user_access;
                        this.edit_user_data.tax_id = this.user_data.tax_details;
                        if(this.edit_user_data.gender == 'custom' || this.edit_user_data.gender == 'Custom') {
                            // this.custom_gender_active = true;
                            this.edit_user_data.gender == 'Custom'
                        }
                        if(this.edit_user_data.tax_id.length > 0) {
                            this.edit_user_data.tax_id.forEach(x => {
                                let n = x.tax_id.split("");
                                Object.assign(x, {
                                    tax1: n[0] == undefined ? '' : n[0],
                                    tax2: n[1] == undefined ? '' : n[1],
                                    tax3: n[2] == undefined ? '' : n[2],
                                    tax4: n[3] == undefined ? '' : n[3],
                                    tax5: n[4] == undefined ? '' : n[4],
                                    tax6: n[5] == undefined ? '' : n[5],
                                    tax7: n[6] == undefined ? '' : n[6],
                                    tax8: n[7] == undefined ? '' : n[7],
                                });
                            });
                        }
                        else {
                            this.edit_user_data.tax_id.push(
                                {
                                    tax1: '',
                                    tax2: '',
                                    tax3: '',
                                    tax4: '',
                                    tax5: '',
                                    tax6: '',
                                    tax7: '',
                                    tax8: '',
                                    tax_id: '',
                                    tax_id_type: ''
                                }
                            );
                        }
                        this.ajax_call_in_progress = false;
                    }
                }
                catch(err) {
                    // console.log(err);
                }
            },
            async updateInfo(type, index) {
                this.tax_id_error = '';
                try {
                    let params = {
                    };
                    let is_tax_id = false;
                    if(type == 'first_name') {
                        params.first_name = this.edit_user_data.first_name;
                        is_tax_id = false;
                    }
                    else if(type == 'middle_name'){
                        params.middle_name = this.edit_user_data.middle_name;
                        is_tax_id = false;
                    }
                    else if(type == 'last_name'){
                        params.last_name = this.edit_user_data.last_name;
                        is_tax_id = false;
                    }
                    else if(type == 'gender'){
                        if(this.edit_user_data.custom_gender.length > 0) {
                            params.gender = 'custom';
                            params.custom_gender = this.edit_user_data.custom_gender;
                        } else {
                            params.gender = this.edit_user_data.gender;
                            params.custom_gender = '';
                        }
                        is_tax_id = false;
                    }
                    else if(type == 'date_of_birth'){
                        params.date_of_birth = this.edit_user_data.date_of_birth.split('/')[2]+'-'+this.edit_user_data.date_of_birth.split('/')[1]+'-'+this.edit_user_data.date_of_birth.split('/')[0];
                        is_tax_id = false;
                    }
                    else if(type == 'about'){
                        params.about = this.edit_user_data.about;
                        is_tax_id = false;
                    }
                    else if(type == 'job_description'){
                        params.job_description = this.edit_user_data.job_description;
                        is_tax_id = false;
                    }
                    else if(type == 'tax_id') {
                        this.edit_user_data.tax_id.forEach((el)=>{
                                el.tax_id = el.tax1+el.tax2+el.tax3+el.tax4+el.tax5+el.tax6+el.tax7+el.tax8
                            });
                        params.tax_details = this.edit_user_data.tax_id;
                        if(params.tax_details[index].tax_id_type == '' || params.tax_details[index].tax_id.length < 8) {
                            is_tax_id = true;
                            this.tax_id_error = 'Select Tax ID and Enter valid Tax ID Type';
                        }
                        else {
                            params.tax_details.forEach((el)=>{
                                delete el.tax1;
                                delete el.tax2;
                                delete el.tax3;
                                delete el.tax4;
                                delete el.tax5;
                                delete el.tax6;
                                delete el.tax7;
                                delete el.tax8;
                            });
                            is_tax_id = false;
                        }
                        let tax_details = params.tax_details.filter(e =>  !(e.tax_id.length === 0 && e.tax_id_type.length === 0));
                        params.tax_details = tax_details;
                        // console.log(params.tax_details);
                    }
                    if(!is_tax_id) {
                        let response = await this.updatePersonalInfo(params, this.loggedInUser.user_id);
                        if(response.status_id == 1) {
                            this.personalInfoData();
                            EventBus.$emit('personal_info_data_update')
                        }
                    }
                }
                catch(err) {
                    // console.log(err);
                }
            }
        },
        props: [],
        mounted() {
            this.personalInfoData();
        },
        created() {
        },
        watch: {
            // "edit_user_data.gender": function(newVal,oldVal) {
            //     if (newVal == 'Custom') {
            //         this.custom_gender_active = true;
            //     } else {
            //         this.custom_gender_active = false;
            //     }
            // },
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            // account() {
            //     return this.$store.getters.account;
            // },
            // selectedCompany() {
            //     return this.$store.getters.selectedCompany;
            // },
        },
    };
</script>
<style scoped>
    .new-contactView-item {
        padding: 16px 10px 16px 3px !important;
    }

    .new-contactView {
        display: flex;
        align-items: center;
    }
    .validation{
        color: red;
    }
    .new-contact-value {
        margin-left: 0px !important;
    }

    /* .form-check-label input[type=radio]~.radio-icon+span,
    .form-check-label input[type=radio]~.custom-control-indicator+span,
    .custom-checkbox input[type=radio]~.radio-icon+span,
    .custom-checkbox input[type=radio]~.custom-control-indicator+span,
    .custom-radio input[type=radio]~.radio-icon+span,
    .custom-radio input[type=radio]~.custom-control-indicator+span {
        padding-left: 0px;
        color: #4e5764 !important;
        font-size: 14px !important;
        padding-right: 10px;
    }

    .form-check-label input[type=radio]~.radio-icon:before,
    .form-check-label input[type=radio]~.radio-icon:after,
    .form-check-label input[type=radio]~.custom-control-indicator:before,
    .form-check-label input[type=radio]~.custom-control-indicator:after{
        border-color: #00448b !important;
    }

    .form-check-label input[type=radio]:checked~.radio-icon:after,
    .form-check-label input[type=radio]:checked~.custom-control-indicator:after{
        background-color: #00448b !important;
    } */
    .form-check-label input[type=radio]~.radio-icon:before,
    .form-check-label input[type=radio]~.radio-icon:after,
    .form-check-label input[type=radio]~.custom-control-indicator:before,
    .form-check-label input[type=radio]~.custom-control-indicator:after{
        border-color: #00448b;
    }

    .form-check-label input[type=radio]:checked~.radio-icon:before,
    .form-check-label input[type=radio]:checked~.custom-control-indicator:before{
        border-color: #00448b !important;
    }

    .form-check-label input[type=radio]:checked~.radio-icon:after,
    .form-check-label input[type=radio]:checked~.custom-control-indicator:after{
        background-color: #00448b !important;
    }

    .form-check-label input[type=radio]:checked~.radio-icon:before,
    .form-check-label input[type=radio]:checked~.custom-control-indicator:before{
        border-color: #00448b !important;
    }

    .a-q-Jc-Lb-editcontactView1 {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-flex: 1 1 auto;
        flex: 1 1 auto;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        text-decoration: none;
        line-height: 1.21;
        letter-spacing: normal;
        color: #303031;
        display: flex;
        justify-content: space-between;
	}
    .new-action-btns {
        position: absolute;
        bottom: 0;
        right: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/PersonalInfoView.vue